import { render, staticRenderFns } from "./DeleteEmployeeModal.vue?vue&type=template&id=beecb022&scoped=true&"
import script from "./DeleteEmployeeModal.vue?vue&type=script&lang=js&"
export * from "./DeleteEmployeeModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteEmployeeModal.vue?vue&type=style&index=0&id=beecb022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beecb022",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle})
